/* ============================================================================
   ag-collection.js
   Extracted from sections/ag-collection.liquid on 2026-04-16
   View density toggle, model/flatlay toggle, sort dropdown,
   load more, sticky filter pill IntersectionObserver.
   ============================================================================ */

(function() {
  'use strict';

  /* === VIEW DENSITY TOGGLE — cycles grid density === */
  /* Desktop: 3 → 4 → 6 cols | Mobile: 1 → 2 → 3 cols */
  /* Level 3 = dense mode (images only, no card text) */
  var densityBtn = document.querySelector('[data-ag-view-density]');
  if (densityBtn) {
    var viewLevel = 2; /* start at level 2 (4 col desktop, 2 col mobile) */
    var bars = densityBtn.querySelectorAll('.ag-view-density__bar');
    var grid = document.querySelector('[data-ag-grid]');

    densityBtn.addEventListener('click', function() {
      viewLevel = viewLevel >= 3 ? 1 : viewLevel + 1;
      if (grid) {
        grid.setAttribute('data-ag-view', viewLevel);
      }
      bars.forEach(function(bar, i) {
        bar.classList.toggle('is-filled', i < viewLevel);
      });
    });
  }

  /* === MODEL TOGGLE — single click swap === */
  var modelToggle = document.querySelector('[data-ag-model-toggle]');
  if (modelToggle) {
    var isModel = true;
    var cells = modelToggle.querySelectorAll('.ag-model-toggle__cell');

    modelToggle.addEventListener('click', function() {
      isModel = !isModel;
      document.body.classList.toggle('ag-view--flatlay', !isModel);
      document.body.classList.toggle('ag-view--model', isModel);
      /* Swap filled cell: model = right filled, flatlay = left filled */
      cells[0].classList.toggle('is-filled', !isModel);
      cells[1].classList.toggle('is-filled', isModel);
    });
  }

  /* === SORT DROPDOWN — close on click outside === */
  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-ag-sort]')) {
      document.querySelectorAll('.ag-sort-dropdown.is-open').forEach(function(d) {
        d.classList.remove('is-open');
      });
    }
  });

  /* === SORT DROPDOWN — navigate on select ===
     Sort options are buttons (not links) so crawlers don't follow ?sort_by= URLs.
     Keeps the existing query string (filter.v.* etc.), sets sort_by, drops page.
     Guarded so it binds once even if this file is included by two sections. */
  if (!window.__agSortBound) {
    window.__agSortBound = true;
    document.addEventListener('click', function(e) {
      var item = e.target.closest('[data-ag-sort-value]');
      if (!item) return;
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', item.getAttribute('data-ag-sort-value'));
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* Size ATC handler now lives in ag-quick-add.liquid (global) */

  /* === LOAD MORE === */
  var loadMoreBtn = document.querySelector('[data-ag-load-more]');
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function() {
      var url = loadMoreBtn.dataset.nextUrl;
      if (!url) return;

      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = 'LOADING...';

      fetch(url)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newProducts = doc.querySelectorAll('.ag-card');
          var grid = document.querySelector('[data-ag-grid]');

          newProducts.forEach(function(card) {
            grid.appendChild(card);
          });

          /* Store original size text for new cards */
          grid.querySelectorAll('.ag-card__size:not([data-original-text])').forEach(function(btn) {
            btn.dataset.originalText = btn.textContent;
          });

          var nextBtn = doc.querySelector('[data-ag-load-more]');
          if (nextBtn && nextBtn.dataset.nextUrl) {
            loadMoreBtn.dataset.nextUrl = nextBtn.dataset.nextUrl;
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = 'LOAD MORE';
          } else {
            loadMoreBtn.parentElement.style.display = 'none';
          }
        })
        .catch(function() {
          loadMoreBtn.textContent = 'ERROR';
        });
    });
  }
  /* === STICKY FILTER PILL — show when static filter scrolls out of view === */
  var pill = document.querySelector('.ag-filter-pill');
  var staticBtn = document.querySelector('[data-ag-filter-static]');
  if (pill && staticBtn) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          pill.classList.remove('is-visible');
        } else {
          pill.classList.add('is-visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(staticBtn);
  }
})();
